import {
  MessagingCampaignDetailsFragment,
  UpdateAudienceBroadcastMessageInput,
} from '@occc/graphql';
import { mergeDateAndTime } from '@occc-app/lib/date';
import { getUpdateChannelsConfigInput } from '@occc/ui-notifications';

import { MessagingCampaignConfigureFormValues } from '../components/configure-form/configure-form.types';
import { MessagingCampaignTargetFormValues } from '../components/target-form/target-form.types';
import { MessagingCampaignScheduleFormInitialValues } from '../components/schedule-form/schedule-form.types';

type ConvertFormFieldsToUpdateInputParams = {
  campaign?: MessagingCampaignDetailsFragment | null;
  configure: Partial<MessagingCampaignConfigureFormValues>;
  target: MessagingCampaignTargetFormValues;
  schedule: MessagingCampaignScheduleFormInitialValues;
};

export const convertFormFieldsToUpdateInput = ({
  campaign,
  configure,
  target,
  schedule,
}: ConvertFormFieldsToUpdateInputParams): UpdateAudienceBroadcastMessageInput => {
  const publishAt = mergeDateAndTime(schedule?.publishAtDate, schedule?.publishAtTime);

  return {
    uuid: campaign?.uuid || '',
    title: configure.title,
    description: configure.description || '',
    audienceUuid: target?.inAudience?.audience?.uuid || '',
    scheduleAt: publishAt?.toISOString(),
    channelsConfig: getUpdateChannelsConfigInput(configure),
  };
};
